export function isPublicBookingHost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  if (h === "book.doctrue.in" || h.startsWith("book-staging.")) return true;
  if (process.env.REACT_APP_PUBLIC_BOOKING_HOST === "1") return true;
  return new URLSearchParams(window.location.search).get("public") === "1";
}

// A link to another booking-site page that keeps `?public=1` when the current
// page has it (local dev / any host that isn't book.doctrue.in), so the
// router stays on the booking site.
export function publicHref(path: string): string {
  if (typeof window === "undefined") return path;
  if (new URLSearchParams(window.location.search).get("public") !== "1") return path;
  return `${path}${path.includes("?") ? "&" : "?"}public=1`;
}
